import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CardComponent} from './components/card/card.component';

import {CatalogComponent} from './components/catalog/catalog.component';
import {CodeHighlighterComponent} from './components/code-highlighter/code-highlighter.component';
import {ComponentContainerComponent} from './components/component-container/component-container.component';
import {ComponentContentComponent} from './components/component-content/component-content.component';
import {ComponentListComponent} from './components/component-list/component-list.component';
import {ContentAreaComponent} from './components/content-area/content-area.component';
import {ContentHeaderComponent} from './components/content-header/content-header.component';
import {HomeComponent} from './components/home/home.component';
import {MarkdownContainerComponent} from './components/markdown-container/markdown-container.component';
import {MarkdownContentComponent} from './components/markdown-content/markdown-content.component';
import {MarkdownListComponent} from './components/markdown-list/markdown-list.component';
import {NavDrawerComponent} from './components/nav-drawer/nav-drawer.component';
import {NavGroupComponent} from './components/nav-group/nav-group.component';
import {NavItemComponent} from './components/nav-item/nav-item.component';
import {TableOfContentsComponent} from './components/table-of-contents/table-of-contents.component';
import {HeadlineDirective} from './directives/headline.directive';
import {ScrollSpyDirective} from './directives/scroll-spy.directive';
import {ComponentCatalogOptions, OPTIONS} from './options.token';

@NgModule({
  declarations: [
    CatalogComponent,
    ComponentContainerComponent,
    ComponentListComponent,
    MarkdownContainerComponent,
    MarkdownListComponent,
    NavDrawerComponent,
    NavGroupComponent,
    NavItemComponent,
    CodeHighlighterComponent,
    TableOfContentsComponent,
    MarkdownContentComponent,
    ContentHeaderComponent,
    ScrollSpyDirective,
    HeadlineDirective,
    CardComponent,
    HomeComponent,
    ContentAreaComponent,
    ComponentContentComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'component-catalog', component: CatalogComponent, children: [
          { path: '', pathMatch: 'full', component: HomeComponent },
          { path: 'components/:group/:id', component: ComponentContainerComponent },
          { path: 'markdowns/:folder/:file', component: MarkdownContainerComponent },
        ],
      },
    ]),
  ],
  exports: [
    HeadlineDirective,
    CodeHighlighterComponent,
  ],
})
export class ComponentCatalogModule {
  static forRoot(options: ComponentCatalogOptions = {}): ModuleWithProviders {
    return {
      ngModule: ComponentCatalogModule,
      providers: [{ provide: OPTIONS, useValue: { ...options } }],
    };
  }
}
